import mainConfig from '../mainConfig';

export default new class Validation {
  constructor() {
    this.error = '.form__requirements';
    this.phoneInputClassName = 'js-phone';
    this.passwordClassName = 'js-password';
    this.bankAccountClassName = 'js-bankAccount';
    this.bankCodeClassName = 'js-bic';
    this.phoneRegExp = /[+][0-9]{3}\s[0-9]{2}\s[0-9]{3}-[0-9]{2}-[0-9]{2}/;
    this.emailRegExp = /^([A-Z|a-z|0-9](\.|_|-){0,1})+([A-Z|a-z|0-9](_){0,1})+@([A-Z|a-z|0-9](\.|_|-){0,1})+((\.){0,1}[A-Z|a-z|0-9]){1}\.[a-z]{2,}$/;
    this.numRegExp = /^[0-9]/g;
    this.isDirtyAttrName = 'data-is-dirty';
    this.errorAnimateSpeed = 150;
    this.formItemField = 'form-item__field';

    this.errorMessageSelector = '.form-item__error-message';
    this.requiredSelector = 'input[required], textarea[required]';
    this.hintSelector = '_hint';
    this.errorSelector = '_error';

    this.validateUntouched = false;

    this.bindEvents();
  }

  /**
     * check does current form is valid
     *
     * @param $form - jQuery obj of form to validate
     * @returns {boolean} - is form valid
     */
  isFormValid($form) {
    const inputs = $form.find('input, textarea');
    const validateUntouched = true;
    let isFormValid = true;

    $form.attr('novalidate', 'novalidate');

    for (let i = 0; i < inputs.length; i += 1) {
      if (!this.validateInput(inputs[i], validateUntouched)) {
        isFormValid = false;
      }
    }

    if (!isFormValid) {
      // if form is invalid execute func to scroll up the viewport to the first error
      this.showTopError();
    }

    return isFormValid;
  }

  /**
     * scroll to the first input with error
     */
  showTopError() {
    const firstErrorMsg = document.querySelector(`.${mainConfig.errorMessages.inputErrorClassName}`);
    if (!firstErrorMsg) return;

    const isVisible = this.checkVisible(firstErrorMsg);
    const offsetFromTop = 25;

    if (!isVisible) {
      $('html, body').animate({
        scrollTop: `${$(firstErrorMsg).offset().top - offsetFromTop}px`,
      }, 'slow');
    }
  }

  /**
     * checking, does elem visible on screen
     *
     * @param elm
     * @param threshold
     * @param mode
     * @returns {boolean}
     */
  checkVisible(elm, thresholdParam, modeParam) {
    const threshold = thresholdParam || 0;
    const mode = modeParam || 'visible';
    const rect = elm.getBoundingClientRect();
    const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
    const above = rect.bottom - threshold < 0;
    const below = rect.top - viewHeight + threshold >= 0;

    if (mode === 'above') return above;

    return mode === 'below' ? below : !above && !below;
  }

  /**
     * add attr data-is-dirty=true
     *
     * @param $input - jQuery obj of input
     */
  setDirty($input) {
    if ($input.val().length) {
      $input.attr(this.isDirtyAttrName, true);
    }
  }

  isDisabledOrHiddenOrButton($input) {
    const isDisabled = !!$input.attr('disabled');
    const isHidden = $input.attr('type') === 'hidden';
    const isButton = $input.attr('type') === 'button';

    if (isDisabled || isHidden || isButton) return true;

    return false;
  }

  toggleErrorMessage($input, isCurrentInputValid) {
    if (isCurrentInputValid) {
      $input.removeClass(mainConfig.errorMessages.inputErrorClassName);

      if (!$input.hasClass(this.hintSelector)) {
        this.hideError($input);
      } else {
        $input.closest(`.${this.formItemField}`).siblings(this.errorMessageSelector).addClass(this.hintSelector);
      }
      return;
    }

    $input.addClass(mainConfig.errorMessages.inputErrorClassName);
    this.showError($input);
  }

  /**
     * validate input, add/remove error classes, shows/hide error msgs
     *
     * @param input - input obj
     * @param validateUntouched - does func need to validate untouched input
     * @returns {boolean}
     */

  validateInput(input, validateUntouched = false) {
    const $input = $(input);

    if (this.isDisabledOrHiddenOrButton($input)) {
      return true;
    }

    const isDirty = $input.attr(this.isDirtyAttrName);
    const isCheckBox = $input.attr('type') === 'checkbox';

    if (isDirty || validateUntouched || isCheckBox) {
      let isCurrentInputValid = input.checkValidity();

      if ($input.hasClass(this.phoneInputClassName)) {
        isCurrentInputValid = this.validatePhoneNumberInput(input);
      }

      if ($input.attr('type') === 'email') {
        isCurrentInputValid = this.emailRegExp.test($input.val().trim());
      }

      this.toggleErrorMessage($input, isCurrentInputValid);

      if ($input.hasClass(this.passwordClassName) && isCurrentInputValid) {
        isCurrentInputValid = this.comparePasswords(input);
      }

      return isCurrentInputValid;
    }

    return false;
  }

  /**
     * shows error message
     *
     * @param $input - input obj
     */
  showError($input) {
    const $error = $input.closest('.form-item').find(this.errorMessageSelector);

    if ($input.hasClass(this.hintSelector) && !$input.hasClass(this.errorSelector)) {
      $error.addClass(this.hintSelector);
    } else {
      $error.removeClass(this.hintSelector);
    }

    $error.stop().slideDown('fast');
  }

  /**
     * hides error message
     *
     * @param $input - input obj
     */
  hideError($input) {
    const $error = $input.closest('.form-item').find(this.errorMessageSelector);

    if (($input.hasClass(this.errorSelector) && $error.hasClass(this.hintSelector)) || $error.hasClass('_file')) {
      return;
    }

    $error.stop().slideUp('fast');
  }

  /**
     * removes error class names from each input/textarea in current form
     *
     * @param $form - jQuerry form object
     */
  removeErrors($form) {
    const inputs = $form.find('input, textarea');

    for (let i = 0; i < inputs.length; i += 1) {
      $(inputs[i]).removeClass(mainConfig.errorMessages.inputErrorClassName);
    }
  }

  /**
     * test does current input val match phone regExp
     *
     * @param input - input obj
     * @returns {boolean} - does input valid
     */
  validatePhoneNumberInput(input) {
    return !!input.value.match(this.phoneRegExp);
  }

  /**
     * add event listeners
     */
  bindEvents() {
    // check input validity on blur
    $(document)
      .on('input cut copy paste change', this.requiredSelector, (e) => {
        this.validateInput(e.target, this.validateUntouched);
      })
      .on('focus', this.requiredSelector, (e) => {
        this.validateUntouched = !!e.currentTarget.value.trim().length;
      })
      .on('blur', this.requiredSelector, (e) => {
        this.setDirty($(e.target));
        this.toggleHint($(e.currentTarget));
        this.validateInput(e.target);
      })
      .on('blur', 'input._hint', (e) => {
        this.toggleHint($(e.currentTarget), true);
      })
      .on('focus', 'input._hint', (e) => {
        this.toggleHint($(e.currentTarget));
      });

    const allowOnlyNumbersAndLetters = (e) => {
      if (!(/[a-z0-9]/i.test(e.key)) || e.charCode === 32) {
        return false;
      }
      return true;
    };

    $(`.${this.bankAccountClassName}`).keypress(allowOnlyNumbersAndLetters);
    $(`.${this.bankCodeClassName}`).keypress(allowOnlyNumbersAndLetters);
  }

  /**
     * Show/hide hint
     */
  toggleHint($input, hideHint) {
    if ($input.hasClass(this.errorSelector)) {
      this.showError($input);
    } else if (!hideHint && $input.hasClass(this.hintSelector)) {
      this.showError($input);
    } else {
      this.hideError($input);
    }
  }

  /**
     * Compare two strings - is them equal
     *
     * @param firstValue
     * @param secondValue
     * @returns {boolean}
     */
  compareString(firstValue, secondValue) {
    return firstValue.toLowerCase() === secondValue.toLowerCase();
  }

  /**
     * Compare two passwords - is them equal
     *
     * @param passwordField
     * @returns {boolean}
     */
  comparePasswords(passwordField) {
    const $input = $(passwordField);
    const $wrapper = $input.closest('form');
    const passwordFields = $wrapper.find(`.${this.passwordClassName}`);
    const passwordValues = [$(passwordFields[0]).val(), $(passwordFields[1]).val()];
    const self = this;

    if (this.isDirty($(passwordFields[0])) && this.isDirty($(passwordFields[1]))) {
      if (this.compareString(passwordValues[0], passwordValues[1])) {
        passwordFields.removeClass(mainConfig.errorMessages.inputErrorClassName);
        passwordFields.each(function hideEachError() {
          const $this = $(this);

          if (!$this.is(':focus')) {
            self.hideError($this);
          }
        });

        return true;
      }
      passwordFields.each(function showEachError() {
        const $this = $(this);

        $this.addClass(this.errorSelector);
        self.showError($this);
      });

      return false;
    }
    return true;
  }

  /**
     * Remove _error class name from input, hide error for input
     *
     * @param $container - $container with inputs
     */
  removeErrorFromFields($container) {
    const $inputs = $container.find('input');

    for (let i = 0; i < $inputs.length; i += 1) {
      $($inputs[i]).removeClass(mainConfig.errorMessages.inputErrorClassName);
      this.hideError($($inputs[i]));
    }
  }

  yearValidation($input, minYear = 1900, maxYearParam = null) {
    const inputVal = $input.val();
    let maxYear = maxYearParam;

    if (!maxYear) {
      maxYear = new Date().getFullYear();
    }

    // allow only number
    if (inputVal && !inputVal.split('')[inputVal.length - 1].match(this.numRegExp)) {
      $input.val(inputVal.split('').slice(0, -1).join(''));
    }

    if (inputVal > maxYear) {
      $input.val(maxYear);
    } else if (inputVal.length === 4 && inputVal < minYear) {
      $input.val(minYear);
    }
  }

  isDirty($input) {
    // eslint-disable-next-line eqeqeq
    return $input.data('is-dirty') != undefined;
  }
}();
